// Register GSAP plugins
gsap.registerPlugin(CustomEase, ScrollTrigger);
// Only register Flip if it's available (loaded from CDN on index template)

if (typeof Flip !== "undefined") {
  gsap.registerPlugin(Flip);
}

const color = {
  primary: "#000",
  gray100: "#f7f7f7",
  gray200: "#cccccc",
  gray300: "#b6b6b6",
  gray600: "#606060",
  secondary: "#fff",
};

// class SectionId {
//   static #separator = '__';

//   // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
//   static parseId(qualifiedSectionId) {
//     return qualifiedSectionId.split(SectionId.#separator)[0];
//   }

//   // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
//   static parseSectionName(qualifiedSectionId) {
//     return qualifiedSectionId.split(SectionId.#separator)[1];
//   }

//   // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
//   static getIdForSection(sectionId, sectionName) {
//     return `${sectionId}${SectionId.#separator}${sectionName}`;
//   }
// }

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(
    oldNode,
    newContent,
    preProcessCallbacks = [],
    postProcessCallbacks = []
  ) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement("div");
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll("[id], [form]").forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form &&
        element.setAttribute(
          "form",
          `${element.form.getAttribute("id")}-${uniqueKey}`
        );
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = "none";

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll("script").forEach((oldScriptTag) => {
      const newScriptTag = document.createElement("script");
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    // this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === "plus") {
      if (
        parseInt(this.input.dataset.min) > parseInt(this.input.step) &&
        this.input.value == 0
      ) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    if (
      this.input.dataset.min === previousValue &&
      event.target.name === "minus"
    ) {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);

    if (this.input.min) {
      const buttonMinus = this.querySelector("[name='minus']");
      if (parseInt(value) <= parseInt(this.input.min)) {
        buttonMinus.setAttribute("disabled", "true");
      } else {
        buttonMinus.removeAttribute("disabled");
      }
    }

    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector("[name='plus']");
      if (value >= max) {
        buttonPlus.setAttribute("disabled", "true");
      } else {
        buttonPlus.removeAttribute("disabled");
      }
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

// /*
//  * Shopify Common JS
//  *
//  */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

// class ProductRecommendations extends HTMLElement {
//   observer = undefined;

//   constructor() {
//     super();
//   }

//   connectedCallback() {
//     this.initializeRecommendations(this.dataset.productId);
//   }

//   initializeRecommendations(productId) {
//     this.observer?.unobserve(this);
//     this.observer = new IntersectionObserver(
//       (entries, observer) => {
//         if (!entries[0].isIntersecting) return;
//         observer.unobserve(this);
//         this.loadRecommendations(productId);
//       },
//       { rootMargin: '0px 0px 400px 0px' }
//     );
//     this.observer.observe(this);
//   }

//   loadRecommendations(productId) {
//     fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
//       .then((response) => response.text())
//       .then((text) => {
//         const html = document.createElement('div');
//         html.innerHTML = text;
//         const recommendations = html.querySelector('product-recommendations');

//         if (recommendations?.innerHTML.trim().length) {
//           this.innerHTML = recommendations.innerHTML;
//         }

//         if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
//           this.remove();
//         }

//         if (html.querySelector('.grid__item')) {
//           this.classList.add('product-recommendations--loaded');
//         }
//       })
//       .catch((e) => {
//         console.error(e);
//       });
//   }
// }

// customElements.define('product-recommendations', ProductRecommendations);

class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector("details");
    this.summaryToggle = this.querySelector("summary");
    this.searchModal = this.querySelector("[data-search-modal]");
    this.backgroundOverlay = this.querySelector("[data-modal-overlay]");
    this.closeButton = this.querySelector('button[type="button"]');

    this.detailsContainer.addEventListener(
      "keyup",
      (event) => event.code.toUpperCase() === "ESCAPE" && this.close()
    );
    this.summaryToggle.addEventListener(
      "click",
      this.onSummaryClick.bind(this)
    );
    this.closeButton.addEventListener("click", this.close.bind(this));

    this.summaryToggle.setAttribute("role", "button");

    this.onKeyDownEvent = this.onKeyDown.bind(this);
    document.addEventListener("keydown", this.onKeyDownEvent);

    this.animation = gsap
      .timeline({
        paused: true,
        defaults: { duration: 0.4, ease: "expo.inOut" },
      })
      .fromTo(
        this.searchModal,
        {
          opacity: 0,
          x: "5rem",
        },
        {
          opacity: 1,
          x: 0,
        }
      )
      .fromTo(
        this.backgroundOverlay,
        {
          opacity: 0,
        },
        {
          opacity: 0.2,
        },
        "<"
      )
      .reverse();
  }

  isOpen() {
    return this.detailsContainer.hasAttribute("open");
  }

  onSummaryClick(event) {
    event.preventDefault();
    this.isOpen() ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (
      !this.contains(event.target) ||
      event.target.hasAttribute("data-modal-overlay")
    ) {
      this.close(false);
    }
  }

  onKeyDown(event) {
    if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === "k") {
      event.preventDefault();
      if (!this.isOpen()) {
        this.open();
      }
    }
  }

  open(event) {
    this.detailsContainer.setAttribute("open", true);
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    document.body.addEventListener("click", this.onBodyClickEvent);
    document.body.classList.add("overflow-hidden");

    this.animation.play();

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    this.animation.reverse().then(() => {
      this.detailsContainer.removeAttribute("open");
      document.body.removeEventListener("click", this.onBodyClickEvent);
      document.body.classList.remove("overflow-hidden");
    });

    removeTrapFocus(focusToggle ? this.summaryToggle : null);
  }

  disconnectedCallback() {
    document.removeEventListener("keydown", this.onKeyDownEvent);
  }
}

customElements.define("details-modal", DetailsModal);

class LoadingBar extends HTMLElement {
  constructor() {
    super();
    this.startLoading = this.startLoading.bind(this);
    this.endLoading = this.endLoading.bind(this);
  }

  connectedCallback() {
    document.addEventListener("loading:start", this.startLoading);
    document.addEventListener("loading:end", this.endLoading);
  }

  disconnectedCallback() {
    document.removeEventListener("loading:start", this.startLoading);
    document.removeEventListener("loading:end", this.endLoading);
  }

  startLoading() {
    gsap.to(this, { width: "80%", duration: 0.25, ease: "power2.out" });
  }

  endLoading() {
    gsap.to(this, {
      width: "100%",
      duration: 0.2,
      ease: "power2.out",
      onComplete: () => {
        gsap.set(this, { width: "0%" });
      },
    });
  }
}

customElements.define("loading-bar", LoadingBar);

function initCheckSectionThemeScroll() {
  // Get detection offset, in this case the navbar
  const navBarHeight = document.querySelector("header");
  const themeObserverOffset = navBarHeight ? navBarHeight.offsetHeight : 0;

  function checkThemeSection() {
    const themeSections = document.querySelectorAll("[data-theme-section]");

    themeSections.forEach(function (themeSection) {
      const rect = themeSection.getBoundingClientRect();
      const themeSectionTop = rect.top;
      const themeSectionBottom = rect.bottom;

      // If the offset is between the top & bottom of the current section
      if (
        themeSectionTop <= themeObserverOffset &&
        themeSectionBottom >= themeObserverOffset
      ) {
        // Update [data-inversed] on header-dropdown based on theme section
        document.querySelectorAll("[data-inversed]").forEach(function (elem) {
          elem.setAttribute("data-inversed", "true");
        });
      } else {
        document.querySelectorAll("[data-inversed]").forEach(function (elem) {
          elem.setAttribute("data-inversed", "false");
        });
      }
    });
  }

  function startThemeCheck() {
    document.addEventListener("scroll", checkThemeSection);
  }

  // Initial check and start listening for scroll
  checkThemeSection();
  startThemeCheck();
}

// Initialize Check Section Theme on Scroll
document.addEventListener("DOMContentLoaded", () => {
  initCheckSectionThemeScroll();
});

// const headerItems = document.querySelectorAll("[data-header-item]");

// // remove all boolean to reset all header items to the default color

// function activateHeaderItemActiveState(currentItem, removeAll = false) {
//   if (removeAll === false) {
//     headerItems.forEach((headerItem) => {
//       gsap.to(headerItem, {
//         color: color.gray300,
//         duration: 0.35,
//         ease: "power2.out",
//       });
//     });
//   } else {
//     headerItems.forEach((headerItem) => {
//       gsap.to(headerItem, {
//         color: color.primary,
//         duration: 0.35,
//         ease: "power2.out",
//       });
//     });
//   }

//   gsap.to(currentItem, {
//     color: color.primary,
//     duration: 0.35,
//     ease: "power2.out",
//   });
// }

// const headerActiveItems = document.querySelectorAll("[data-header-item]");

// headerActiveItems.forEach((item) => {
//   if (item.tagName === "A" || item.tagName === "LI") {
//     if (!item.hasAttribute("data-cart-button")) {
//       item.addEventListener("pointerenter", () => {
//         activateHeaderItemActiveState(item);
//       });

//       item.addEventListener("pointerleave", () => {
//         activateHeaderItemActiveState((removeAll = true));
//       });
//     }
//   }
// });

class LazyImage extends HTMLElement {
  constructor() {
    super();
    this.img = null;
    this.intersectionObserver = null;
  }

  connectedCallback() {
    this.img = this.querySelector("img");
    if (!this.img) return;

    this.intersectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          const src = this.img.getAttribute("data-lazy-src");
          if (src) {
            this.img.src = src;
            this.img.classList.remove("animate-pulse");
          }

          this.intersectionObserver.disconnect();
        });
      },
      { rootMargin: "200px" }
    );

    this.intersectionObserver.observe(this.img);
  }
}

customElements.define("lazy-image", LazyImage);

// aside

document.addEventListener('DOMContentLoaded', () => {
  const aside = document.querySelector('[data-aside]');
  const asideButton = document.querySelector('[data-aside-close]');
  if (!aside) return;

  const COOKIE_NAME = 'aside_closed';
  const COOKIE_DAYS = 14;

  const setCookie = (name, value, days) => {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
  };

  const getCookie = (name) => {
    return document.cookie
      .split('; ')
      .find((row) => row.startsWith(`${name}=`))
      ?.split('=')[1];
  };

  if (getCookie(COOKIE_NAME) === 'true') return;

  let isVisible = false;

  const showAside = () => {
    if (isVisible) return;
    isVisible = true;

    gsap.fromTo(
      aside,
      { y: '100%' },
      {
        y: '0%',
        duration: 0.25,
        ease: 'custom-ease',
      }
    );
  };

  const hideAside = () => {
    if (!isVisible) return;
    isVisible = false;

    gsap.to(aside, {
      y: '100%',
      duration: 0.25,
      ease: 'custom-ease',
    });
  };

  window.addEventListener(
    'scroll',
    () => {
      if (window.scrollY >= 200) {
        showAside();
      }

      if (window.scrollY <= 10) {
        hideAside();
      }
    },
    { passive: true }
  );

  asideButton?.addEventListener('click', () => {
    gsap.to(aside, {
      y: '100%',
      duration: 0.25,
      ease: 'custom-ease',
      onComplete: () => {
        aside.style.display = 'none';
        setCookie(COOKIE_NAME, 'true', COOKIE_DAYS);
      },
    });
  });
});



// function initBasicCustomCursor() {
//   const cursor = document.createElement("div");
//   cursor.classList.add("cursor");
//   document.body.appendChild(cursor);

//   const style = document.createElement("style");
//   style.textContent = `
// .cursor {
//   z-index: 10000;
//   background-color: #ffffff;
//   border-radius: 9999px;
//   width: 12px;
//   height: 12px;
//   position: fixed;
//   inset: 0% auto auto 0%;
//   pointer-events: none;
//   mix-blend-mode: difference;
//   opacity: 0;
//   transition:
//     background-color .375s cubic-bezier(.625, .05, 0, 1),
//     height .375s cubic-bezier(.625, .05, 0, 1),
//     width .375s cubic-bezier(.625, .05, 0, 1);
// }

// body:has(a:hover) .cursor,
// body:has(button:hover) .cursor,
// body:has([data-cursor]:hover) .cursor {
//   width: 24px;
//   height: 24px;
//   background-color: rgba(255, 255, 255, 0.9);
// }

// @media (hover: none) and (pointer: coarse) {
//   .cursor {
//     display: none;
//   }
// }
// `;
//   document.head.appendChild(style);

//   gsap.set(cursor, { xPercent: -50, yPercent: -50 });
//   gsap.set(cursor, { xPercent: -50, yPercent: -50 });

//   const xTo = gsap.quickTo(cursor, "x", { duration: 0.2, ease: "power3" });
//   const yTo = gsap.quickTo(cursor, "y", { duration: 0.2, ease: "power3" });
//   const opacityTo = gsap.quickTo(cursor, "opacity", {
//     duration: 0.15,
//     ease: "power2.out",
//   });

//   // show on first real movement inside viewport
//   window.addEventListener("mousemove", (e) => {
//     xTo(e.clientX);
//     yTo(e.clientY);
//     opacityTo(1);
//   });

//   // fires when cursor leaves the viewport (reliable)
//   document.documentElement.addEventListener("mouseleave", () => {
//     opacityTo(0);
//   });

//   // fires when browser window loses focus (alt-tab, another monitor, etc.)
//   window.addEventListener("blur", () => {
//     opacityTo(0);
//   });

//   // hide on explicit opt-out areas
//   document.addEventListener("mousemove", (e) => {
//     if (e.target.closest("[data-cursor-none]")) {
//       console.log("hide cursor");
//       opacityTo(0);
//     }
//   });
// }

// document.addEventListener("DOMContentLoaded", () => {
//   if (window.innerWidth > 1024) {
//     initBasicCustomCursor();
//   }
// });
